import { countries } from "../shared/grailConstants";
import { Country } from "../shared/types";
import { useMemo } from "react";
import {
  Combobox,
  ComboboxContent,
  ComboboxEmpty,
  ComboboxInput,
  ComboboxItem,
  ComboboxList,
} from "@/components/ui/combobox";
import { formComboboxInputClassName } from "@/components/forms/FormCombobox";
import { cn } from "cn";

interface CountrySelectProps {
  isErrored?: boolean;
  onChange: (...event: unknown[]) => void;
  readOnly?: boolean;
  required?: boolean;
  showCountryCode?: boolean;
  showPhoneCode?: boolean;
  value?: any; // string | Country
}

function resolveCountry(value: unknown): Country | null {
  if (value == null || value === "") return null;
  if (typeof value === "string") {
    return (
      countries.find(
        (opt) =>
          opt.label.toLowerCase() === value.toLowerCase() ||
          opt.alternateCode?.toLowerCase() === value.toLowerCase() ||
          opt.code.toLowerCase() === value.toLowerCase()
      ) || null
    );
  }
  return value as Country;
}

export default function CountrySelect(props: CountrySelectProps) {
  const {
    isErrored,
    onChange,
    readOnly,
    required,
    showCountryCode,
    showPhoneCode,
    value,
  } = props;

  const options = useMemo(
    () => [...countries].sort((a, b) => (a.label > b.label ? 1 : -1)),
    []
  );

  const selected = resolveCountry(value);

  return (
    <Combobox
      id="country-select-demo"
      items={options}
      value={selected}
      onValueChange={(next) => onChange(next)}
      readOnly={readOnly}
      required={required}
      autoHighlight
      autoComplete="new-password"
      itemToStringLabel={(option) => option.label}
      isItemEqualToValue={(option, current) =>
        option.label?.toLowerCase() === current.label?.toLowerCase() ||
        option.code === current.code
      }
    >
      <ComboboxInput
        name="country"
        disabled={readOnly}
        showClear={!readOnly}
        aria-invalid={isErrored || undefined}
        className={cn(
          formComboboxInputClassName,
          isErrored && "border-destructive"
        )}
      />
      <ComboboxContent>
        <ComboboxEmpty>No countries found.</ComboboxEmpty>
        <ComboboxList>
          {(option) => (
            <ComboboxItem key={option.code} value={option}>
              <img
                loading="lazy"
                width="20"
                src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                alt=""
                className="mr-2 shrink-0"
              />
              {option.label}
              {showCountryCode ? <span>({option.code})</span> : null}
              {showPhoneCode ? <span>(+{option.phone})</span> : null}
            </ComboboxItem>
          )}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
